<template><svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 500 85">
  
  <defs>
    
  </defs>
  <g>
    <path class="st0" d="M61.5,62.6H6.1v-8.6h4.3c-4-2.8-4.3-7-4.3-17.1v-2.3h8.6v7.9c0,11.1,9.7,10.8,18.7,10.8h28.1v9.4Z"/>
    <path class="st0" d="M6.1,23.8h55.4v8.6h-4.3c4,2.8,4.3,7,4.3,17.1v2.3h-8.6v-7.9c0-11.1-9.7-10.8-18.7-10.8H6.1v-9.4Z"/>
    <circle class="st0" cx="56.1" cy="14.1" r="6.1"/>
  </g>
  <path class="st0" d="M123.3,26c0-10.8-7.7-18-19.6-18h-22.1v54.7h11.5v-18.7h10.1l9.4,18.7h13l-11.5-21.6c5.8-2.9,9.4-7.9,9.4-15.1ZM102.8,33.9h-9.7v-16.5h9.7c5.5,0,9.1,3.6,9.1,8.6s-3.6,7.9-9.1,7.9Z"/>
  <path class="st0" d="M172.8,23.1h-12.2s-7.9,11.5-7.9,11.5l-8.6-11.5h-12.2s14.4,19.4,14.4,19.4l-15.1,20.1h11.5l9.4-12.2,9.4,12.2h12.2l-15.1-20.1,14.4-19.4Z"/>
  <path class="st0" d="M216.5,32.4h-30.9V8h-3.6v54.7h3.6v-27.3h30.9v27.3h3.6V8h-3.6v24.5Z"/>
  <path class="st0" d="M262.6,55.4v-18.7c0-8.6-5-14.4-15.1-14.4s-15.1,4.3-15.8,11.5h3.6c.7-5,5.8-8.6,12.2-8.6s11.5,5,11.5,11.5v3.6h-13.7c-10.1,0-15.1,4.3-15.1,11.5s5.8,11.5,13.7,11.5,13-3.6,15.1-8.6v1.4c0,4.3,1.4,6.5,6.5,6.5h2.2v-2.9h-1.4c-2.2,0-3.6-.7-3.6-4.3ZM259,46.8c0,7.2-5.8,13.7-15.1,13.7s-10.1-4.3-10.1-9.4,4.3-7.9,11.5-7.9h13.7v3.6Z"/>
  <path class="st0" d="M280.6,30.3v-7.2h-3.6v39.6h3.6v-20.9c0-7.9,2.2-15.1,11.5-15.1h2.9v-3.6h-2.2c-7.3,0-10.8,2.9-12.2,7.2Z"/>
  <path class="st0" d="M346.1,22.4c-7.2,0-11.5,3.6-13.7,9.4-2.2-6.5-7.2-9.4-13.7-9.4s-10.8,3.6-12.9,8.6v-7.9h-3.6v39.6h3.6v-20.9c0-9.4,4.3-16.5,12.2-16.5s12.2,5.8,12.2,14.4v23h3.6v-23c0-8.6,3.6-14.4,11.5-14.4s13,5,13,13.7v23.7h3.6v-23.7c0-11.5-7.9-16.5-15.8-16.5h0Z"/>
  <path class="st0" d="M388.5,22.4c-10.8,0-18.7,8.6-18.7,20.1s7.9,20.9,18.7,20.9,18.7-9.4,18.7-20.9-7.9-20.1-18.7-20.1ZM388.5,60.5c-8.6,0-15.1-8.6-15.1-18s6.5-17.3,15.1-17.3,15.1,7.2,15.1,17.3-6.5,18-15.1,18Z"/>
  <path class="st0" d="M434.5,22.4c-7.2,0-11.5,3.6-13.6,8.6v-7.9h-3.6v39.6h3.6v-20.1c0-10.1,5-17.3,13.7-17.3s13,5.8,13,15.1v22.3h3.6v-22.3c0-12.2-7.9-18-16.6-18h0Z"/>
  <path class="st0" d="M488.5,23.1l-13.7,34.5-14.4-34.5h-3.6l16.6,38.8-2.9,6.5c-2.2,4.3-2.9,5.8-7.2,5.8h-5v2.9h5.8c5,0,6.5-1.4,9.4-7.9l18.7-46h-3.6Z"/>
</svg></template>
<style>
      .st0 {
        fill: #20413d;
      }
    </style>
<script>
export default {}
</script>